// extracted by mini-css-extract-plugin
module.exports = {"container":"Contacts_container__k6hy1","description":"Contacts_description__1Rz-3","links":"Contacts_links__2ULMD","links-item":"Contacts_links-item__351_l"};